export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.12-0904.56",
  commitId: "d76a5ab81033989e444561085be528c0886f1799",
  commitTime: "2026-06-12T09:04:56.000Z",
});
